import { render } from "./IndexOverPayment.vue?vue&type=template&id=0c2ac710&scoped=true"
import script from "./IndexOverPayment.vue?vue&type=script&lang=js"
export * from "./IndexOverPayment.vue?vue&type=script&lang=js"

import "./IndexOverPayment.vue?vue&type=style&index=0&id=0c2ac710&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2ac710"]])

export default __exports__